// ─── Mises en Pratique du module Calendrier ──────────────────────
// Contenu SPÉCIFIQUE au module (la mécanique — runner, progression — vit dans
// le Core : ApprentissageProvider/BarrePratique). L'app compose les registres.
// Champs = CLÉS i18n (section mep du catalogue), traduites au rendu.
export const PRATIQUES_CALENDRIER = {
  calendrier: [
    {
      id: 'premierEvenement', emoji: '📅',
      titre: 'mep.calPremEvtT', sousTitre: 'mep.calPremEvtS',
      etapes: [
        { consigne: 'mep.calPremEvt1' },
        { consigne: 'mep.calPremEvt2' },
        { consigne: 'mep.calPremEvt3' },
        { consigne: 'mep.calPremEvt4' },
      ],
    },
    {
      id: 'naviguerVues', emoji: '🗓️',
      titre: 'mep.calVuesT', sousTitre: 'mep.calVuesS',
      etapes: [
        { consigne: 'mep.calVues1' },
        { consigne: 'mep.calVues2' },
        { consigne: 'mep.calVues3' },
        { consigne: 'mep.calVues4' },
      ],
    },
    {
      id: 'filtrer', emoji: '🏷️',
      titre: 'mep.calFiltT', sousTitre: 'mep.calFiltS',
      etapes: [
        { consigne: 'mep.calFilt1' },
        { consigne: 'mep.calFilt2' },
        { consigne: 'mep.calFilt3' },
      ],
    },
    {
      id: 'echangerGarde', emoji: '🧷',
      titre: 'mep.calGardeT', sousTitre: 'mep.calGardeS',
      etapes: [
        { consigne: 'mep.calGarde1' },
        { consigne: 'mep.calGarde2' },
        { consigne: 'mep.calGarde3' },
      ],
    },
  ],
};

export default PRATIQUES_CALENDRIER;
